// src/shared/Administration/ConfirmEmail.tsx
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/axios';

const ConfirmEmail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setToken } = useAuth();
  const location = useLocation();

  const [message, setMessage] = useState(t('confirmEmailLoading'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let timeoutId: any;

    (async () => {
      const token = new URLSearchParams(location.search).get('token');

      if (!token) {
        setMessage(t('confirmEmailError'));
        setLoading(false);
        return;
      }

      // ✅ Store access token in memory only (AuthContext -> axios interceptor)
      setToken(token);

      try {
        // ✅ No need to pass Authorization header manually;
        // interceptor will attach it after setToken()
        const me = await api.get('/users/me');

        setMessage(t('confirmEmailSuccess'));
        setLoading(false);

        const to =
          me?.data?.firstRunComplete === false
            ? '/firstRun'
            : '/gallery';

        timeoutId = setTimeout(() => navigate(to, { replace: true }), 800);
      } catch (e) {
        console.error('ConfirmEmail: /users/me failed', e);
        setMessage(t('confirmEmailError'));
        setLoading(false);
      }
    })();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return (
    <div style={{ textAlign: 'center', marginTop: '150px', color: '#bbb' }}>
      {loading && (
        <div style={{ marginBottom: 20 }}>
          <div
            style={{
              width: 50,
              height: 50,
              border: '6px solid #ccc',
              borderTop: '6px solid #4CAF50',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite',
              margin: '0 auto',
            }}
          />
          <style>
            {`@keyframes spin { 0%{transform:rotate(0)} 100%{transform:rotate(360deg)} }`}
          </style>
        </div>
      )}
      <h2>{message}</h2>
    </div>
  );
};

export default ConfirmEmail;
